import React from "react";
import SocialIcons from "./reusables/SocialIcons";
import LazyImage from "./reusables/LazyImage";
import { Link } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa";
import { EXTERNAL_URLS, PERSONAL_INFO, BUTTON_TEXT } from "../constants";

const Hero = React.memo(() => {
	return (
		<section id='Hero' className='isolate bg-transparent py-20 sm:py-24' role='banner'>
			<div className='relative mx-auto max-w-7xl px-4 lg:px-16 mt-24 sm:mt-0'>
				<div className='max-w-2xl justify-end'>
					<LazyImage
						className='absolute inset-0 object-cover mt-2 pl-72 ml-96 h-full z-[-1] hidden sm:block'
						src={PERSONAL_INFO.AVATAR_URL}
						alt={`Professional headshot of ${PERSONAL_INFO.FULL_NAME}, a software engineer`}
						loading='eager'
						width='400'
						height='400'
					/>

					<div className='hidden sm:flex sm:justify-left'>
						<div className='border-b-8 border-gray-900 w-32 mt-16' aria-hidden='true'></div>
					</div>

					<header className='text-left mt-6'>
						<h1 className='text-4xl font-bold leading-10 md:leading-tight tracking-wide text-gray-900 sm:text-6xl md:mt-0 text-center md:text-left'>
							I'M {PERSONAL_INFO.NAME} A {PERSONAL_INFO.TITLE}
						</h1>

						<p className='text-lg leading-8 text-gray-600 text-center md:text-left mt-12 sm:mt-4'>
							{PERSONAL_INFO.DESCRIPTION}
						</p>

						<div className='flex justify-left gap-x-6 mt-12 sm:mt-6'>
							<Link
								to={EXTERNAL_URLS.WHATSAPP}
								target='_blank'
								rel='noopener noreferrer'
								className='bg-gray-900 px-7 py-4 text-sm font-bold tracking-wide text-white shadow-sm hover:bg-transparent hover:border-gray-900 hover:text-gray-900 border-2 border-gray-900 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 mx-auto md:mx-0'
								aria-label='Start a conversation on WhatsApp'>
								{BUTTON_TEXT.LETS_TALK} <span aria-hidden='true'>&rarr;</span>
							</Link>
						</div>

						<nav className='absolute right-16 z-50 md:block hidden' aria-label='Scroll to services'>
							<a href='#Services' aria-label='Scroll down to services section'>
								<div className='bg-gray-900 text-white rounded-full p-8 cursor-pointer hover:bg-gray-800 transition-colors'>
									<FaAngleDown size={26} aria-hidden='true' />
								</div>
							</a>
						</nav>

						<aside className='flex flex-col items-left justify-left space-y-2 text-center md:text-left mt-12 sm:mt-0' aria-label='Social media links'>
							<h2 className='mt-6 mb-2 text-gray-900 text-lg font-semibold'>
								{BUTTON_TEXT.FOLLOW_ME}
							</h2>
							<div className='flex justify-center md:justify-start md:space-x-6' role='list'>
								<SocialIcons />
							</div>
						</aside>
					</header>
				</div>
			</div>
		</section>
	);
});

Hero.displayName = 'Hero';

export default Hero;
